<template>
  <v-card>
    <v-card-text>
      <h5 class="text-center mb-0 pb-0">Recibos generados manualmente</h5>
      <p class="text-right mt-0 pt-0"> 
        <vue-json-to-csv
        v-if="data_download.length > 0"
        class="mt-0"
          :json-data="data_download"
          :csv-title="file_name"
          @success="(val) => downloadSuccess(val)"
          @error="(val) => downloadError(val)"
        >
          <!-- <v-btn small color="success" rounded outlined> Descargar Reporte <v-icon class="ma-1">mdi-microsoft-excel</v-icon> </v-btn> -->
          <button></button>
        </vue-json-to-csv>
      </p>
      <download-excel class="btn btn-info" :data="data_download" :fields="json_fields" worksheet="Recibos" name="recibos.xls">
        <v-icon class="ma-0" color="white">mdi-download</v-icon> Descargar Datos en excel
      </download-excel>
      <v-btn small class="mx-4" @click="$router.push('/recibosesam')" color="info" outlined> <v-icon>mdi-home</v-icon> Generar Recibo</v-btn>
      <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn> -->

      <v-row>
        <v-col cols="12" sm="12" class="ma-0 text-end">
          <v-btn class="ma-1" small color="success" @click="cargarRecibos(1, 1)">Ver Todos</v-btn>
          <v-btn class="ma-1" small color="red" @click="cargarRecibos(1, 0)">Ver Eliminados</v-btn>
        </v-col>
        <v-col lg="2" md="3" sm="12" class="mt-0">
          <v-text-field class="mt-4 mb-0 pb-0" v-model.trim="search_text" label="Buscar por nombre" id="id" dense autofocus></v-text-field>
        </v-col>
        <v-col lg="2" md="3" sm="6" xl="6" class="mt-0" :class="{ 'has-error': validation.hasError('busqueda.fecha_ini') }">
          <span>Fecha inicio:</span>
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini" />
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')">{{ validation.firstError('busqueda.fecha_ini') }}</div>
        </v-col>
        <v-col lg="2" md="3" sm="6" xl="6" class="mt-0" :class="{ 'has-error': validation.hasError('busqueda.fecha_fin') }">
          <span>Fecha fin:</span>  
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin" />
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')">{{ validation.firstError('busqueda.fecha_fin') }}</div>
        </v-col>
        <v-col md="3" sm="12" class="mt-0">
          <v-btn class="mt-4" color="info" @click="cargarRecibos(null, 1)">Buscar</v-btn>
        </v-col>
      </v-row>

      <div class="table-responsive">
        <p style="margin-bottom: 0">
          <small> Recibos encontrados: {{ recibos.length }} </small>
        </p>
        <table class="table table-striped table-condensed">
          <thead>
            <tr>
              <th>Nro</th>
              <th>Estudiante</th>
              <th>Monto</th>
              <th>Asesor</th>
              <th>Emisor</th>
              <th>Lugar</th>
              <th>Fecha</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="ind" v-for="(recibo, ind) in recibos">
              <td>00{{ recibo.nro }}</td>
              <td>{{ recibo.estudiante }}</td>
              <td>{{ recibo.monto }}</td>
              <td>{{ recibo.asesor }}</td>
              <td>{{ recibo.emisor }}</td>
              <td>{{ recibo.lugar }}</td>
              <td>{{ parseFecha(recibo.fecha_pago, recibo.nro) }}</td>
              <td>
                <button class="btn btn-link btn-sm" :disabled="!recibo.archivo_id" @click="cargarBase64File(recibo)" data-toggle="modal" data-target="#modal-recibo">
                  <span class="glyphicon glyphicon-eye-open"></span>
                </button>
                <!-- <button :disabled="!$store.state.eliminarRecibo" class="btn btn-link btn-sm" @click="preAnularRecibo(recibo)">
                  <span class="glyphicon glyphicon-remove"></span>
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-recibo">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" style="background-color: #161d30;"> 
            <div class="modal-body pa-0 ma-0">
              <iframe :src="base64pdf" width="100%" height="550"></iframe>
              <v-progress-linear v-if="!base64pdf" indeterminate/>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-warning white--text" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

      <notifications group="auth" position="bottom right" />
      <Alertas ref="xxalertar" />
    </v-card-text>
  </v-card>
</template>

<script>
import gql from 'graphql-tag';
import VueJsonToCsv from 'vue-json-to-csv';
import Fecha from '@/components/AFecha.vue';
import Alertas from '@/components/AAlertas.vue';
import { Validator } from 'simple-vue-validator';
import { error } from '@/components/Utils.js';
import xaxios from '@/xaxios';

export default {
  data() {
    return {
      file_name: 'Mis_Recibos_' + Date.now().toString(),
      busqueda: { fecha_ini: null, fecha_fin: null },
      search_text: null,
      activo: true,
      fecha_ini: '',
      fecha_fin: '',
      recibos: [],
      self: {},
      data_download: [],
      base64pdf:'',


      json_fields: {
        'Sede': 'Sede',
        'Lugar': 'Lugar',
        'Numero': 'Numero',
        'Numero Documento': 'Numero Documento',
        'Factura': 'Factura',
        'Estudiante': 'Estudiante',
        'Num Cuota': 'Num Cuota',
        'Monto': 'Monto',
        'Saldo': 'Saldo',
        'Forma Pago': 'Forma Pago',
        'Concepto': 'Concepto',
        'Celular': 'Celular',
        'Telefono': 'Telefono',
        'Direccion': 'Direccion',
        'Zona': 'Zona',
        'Fecha Pago': 'Fecha Pago',
        'Proximo Pago': 'Proximo Pago',
        'Asesor': 'Asesor',
        'Emisor': 'Emisor',
      },
    };
  },
  components: { Fecha, Alertas, VueJsonToCsv },
  validators: {
    'busqueda.fecha_ini'(value) {
      return Validator.value(value).required();
    },
    'busqueda.fecha_fin'(value) {
      return Validator.value(value).required();
    },
  },

  watch:{
    '$store.state.CARGO': function(){
      // window.console.log('cambio de sede',this.$store.state.CARGO);
      this.cargarRecibos(null,1);
    }
  },

  methods: {
    downloadSuccess(val) {
      val ? this.$root.$notify.show('Datos .CSV Descargados', { color: 'success' }) : null;
    },
    downloadError(val) {
      val ? this.$root.$notify.show('Error Datos No encontrados', { color: 'red' }) : null;
    },
    parseFecha(f) {
      var strs = f.split('T');
      var fs = strs[0].split('-');
      return fs[2] + '/' + fs[1] + '/' + fs[0];
    },
    cargarRecibos(todos, tipo) {
      if (!this.busqueda.fecha_ini || !this.busqueda.fecha_fin) {
        this.$notify(error('Faltan parametros', 'Complete los campos de fechas'));
        return;
      }
      this.$refs.xxalertar.cargando();
      var vue = this;
      var idsede = this.$store.state.CARGO.idsede;
      // tipo= 0 inactivo, 1 activo 2
      var cargo = this.$store.state.CARGO.id;
      this.recibos = [];
      var filter = '';
      if (this.search_text) filter = this.search_text;
      else filter = null;
      var sql = ``;
      if (cargo == 1 || todos) {
        // admin
        if (filter) {
          sql = `(search_text:"${filter}",sede_id:${idsede},fechas:${window.stringifyObject(this.busqueda)},tipo:${tipo})`;
        } else {
          sql = `(sede_id:${idsede},fechas:${window.stringifyObject(this.busqueda)},tipo:${tipo})`;
        }
      } else {
        var iduser = this.$store.state.DATA_USER.id;
        if (filter) {
          sql = `(search_text:"${filter}",sede_id:${idsede},fechas:${window.stringifyObject(this.busqueda)},usuario_id:${iduser},tipo:${tipo})`;
        } else {
          sql = `(sede_id:${idsede},fechas:${window.stringifyObject(this.busqueda)},usuario_id:${iduser},tipo:${tipo})`;
        }
      }
      sql = gql`query{ getRecibos${sql}{id,codigo,archivo_id,nro,lugar,num_doc,nro_factura,direccion,zona,estudiante,telefono,celular,concepto,forma_pago,monto,saldo,num_cuota,fecha_pago,proximo_pago,fecha_registro,asesor,emisor,recibo_fondo,sede_id,usuario_id,estado,sede{nombre},usuario{nombres,pri_apellido, usuario{firma} }} }`;
      // window.console.log( sql );

      this.$apollo
        .query({ query: sql })
        .then(({ data: { getRecibos } }) => {
          let res = getRecibos;
          res = res.sort((a, b) => b.nro - a.nro);
          this.recibos = res;
          this.formatDataDownload(this.recibos);
          this.$refs.xxalertar.reset();
        })
        .catch((error) => {
          vue.activo = true;
          vue.msg = error;
          vue.$refs.xxalertar.reset();
          this.$root.$notify.show('Error getRecibos', { color: 'red' });
        });
    },
    formatDataDownload(data) {
      // let only_data = ['nro','lugar','num_doc','nro_factura','direccion','zona','estudiante','telefono','celular','concepto','forma_pago','monto','saldo','num_cuota','fecha_pago','proximo_pago','asesor','emisor', 'sede', 'usuario'];
      this.data_download = data.map((recibo) => {
        let data = {};
        // data.usuario = recibo.usuario.usuario.{ nombres, pri_apellido, usuario{firma} }
        data.Sede = recibo.sede.nombre;
        data.Lugar = recibo.lugar ? recibo.lugar : '';
        data.Numero = recibo.nro ? recibo.nro : '';
        data['Numero Documento'] = recibo.num_doc ? recibo.num_doc : '';
        data.Factura = recibo.nro_factura ? recibo.nro_factura : '';
        data.Estudiante = recibo.estudiante ? recibo.estudiante : '';
        data['Num Cuota'] = recibo.num_cuota ? recibo.num_cuota : '';
        data.Monto = recibo.monto ? recibo.monto : '';
        data.Saldo = recibo.saldo ? recibo.saldo : '';
        data['Forma Pago'] = recibo.forma_pago ? recibo.forma_pago : '';
        data.Concepto = recibo.concepto ? recibo.concepto : '';
        data.Celular = recibo.celular ? recibo.celular : '';
        data.Telefono = recibo.telefono ? recibo.telefono : '';
        data.Direccion = recibo.direccion ? recibo.direccion : '';
        data.Zona = recibo.zona ? recibo.zona : '';
        data['Fecha Pago'] = recibo.fecha_pago ? recibo.fecha_pago : '';
        data['Proximo Pago'] = recibo.proximo_pago ? recibo.proximo_pago : '';
        data['Asesor'] = recibo.asesor ? recibo.asesor : '';
        data.Emisor = recibo.emisor ? recibo.emisor : '';
        return data;
      });
    },

    /*viewRecibo(recibo) {
      this.self = recibo;
      var c = document.getElementById('myCanvasm2');
      var ctx = c.getContext('2d');
      ctx.clearRect(0, 0, c.width, c.height);

      let fondo_img = new Image();
      let img_firma = new Image();
      fondo_img.src = process.env.VUE_APP_URL_BG_RECIBO_SEDE + recibo.recibo_fondo;
      img_firma.src = process.env.VUE_APP_URL_BG_FIRMA_USER + recibo.usuario.usuario.firma;
      // window.console.log('recibo', recibo, ' fondo ', fondo_img.src, ' firma ', img_firma.src);
      var vue = this;
      // load fondo_recibo
      fondo_img.onload = function () {
        ctx.drawImage(fondo_img, 0, 0, 840, 700);
        if (recibo.recibo_fondo != recibo.usuario.usuario.firma) ctx.drawImage(img_firma, 310, 550, 230, 110);
        vue.generateImg(recibo, c, ctx);
      };
      fondo_img.onerror = function () {
        // vue.showError(`Fondo ${fondo_img.src} no encontrado`);
      };
      // load firma
      // img_firma.onload = function () {
      //   ctx.drawImage(img_firma, 310, 550, 230, 110);
      //   vue.generateImg(recibo, c, ctx);
      // };
      // img_firma.onerror = function () {
      //   // vue.showError(`Firma ${img_firma.src} no encontrado`);
      // };
    },*/
    async cargarBase64File(recibin){
      this.base64pdf = '';
      // window.console.log("cargarBase64File:", recibin);
      let config = {
        method: 'get', 
        url: `${process.env.VUE_APP_SERVERFILES}${recibin.archivo_id}`, 
        headers: { 
          'Content-Type': 'application/json'
        }, 
      };

      let res = await xaxios.request(config).then((response) => response.data).catch((error) => error); 
      let b64 = `data:${res.mimetype};base64,${res.file64}`;
      this.base64pdf = b64;
    },

    showError(sms) {
      this.$root.$notify.show(sms, { color: 'orange' });
    },

    /*generateImg(recibo, c, ctx) {
      var dia = '';
      var mes = '';
      var anio = '';
      recibo.proximo_pago = recibo.proximo_pago ? recibo.proximo_pago.split('T')[0].split('-').reverse().join('/') : '';

      var fr = recibo.fecha_pago.split('T')[0].split('-');
      dia = fr[2];
      mes = fr[1];
      anio = fr[0];

      ctx.font = '17px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('' + recibo.lugar, c.width / 2 - 330, 250);
      ctx.fillText('' + recibo.estudiante, c.width / 2 - 40, 342);
      recibo.zona ? ctx.fillText('' + recibo.zona.slice(0, 16), 410, 390) : null;
      recibo.num_doc ? ctx.fillText('' + recibo.num_doc, c.width / 2 + 270, 342) : null;
      recibo.direccion ? ctx.fillText('' + recibo.direccion.slice(0, 22), 220, 390) : null;

      ctx.fillText('' + recibo.emisor, c.width / 2 + 220, 548);
      ctx.fillText('' + recibo.asesor, c.width / 2 - 180, 548);
      if (recibo.celular) ctx.fillText('' + recibo.celular, c.width / 2 + 160, 390);
      if (recibo.nro_factura) {
        ctx.font = '15px Arial';
        ctx.textAlign = 'center';
        ctx.fillStyle = '#03407c';
        ctx.fillText('Fac.', c.width / 2 + 250, 390);
        ctx.font = '17px Arial';
        ctx.fillStyle = 'black';
        recibo.nro_factura ? ctx.fillText('' + recibo.nro_factura, c.width / 2 + 325, 390) : null;
      }
      ctx.fillText('' + recibo.concepto, c.width / 2 + 50, 431);
      ctx.fillText('' + recibo.forma_pago, c.width / 2 + 20, 474);
      ctx.fillText('' + recibo.monto + ' Bs.', c.width / 2 - 270, 512);
      if (recibo.saldo > 0) ctx.fillText('' + recibo.saldo + ' Bs.', c.width / 2 - 70, 512);
      else if (recibo.saldo == 0) ctx.fillText('0 Bs.', c.width / 2 - 70, 512);
      if (recibo.num_cuota) ctx.fillText('' + recibo.num_cuota, c.width / 2 + 90, 512);
      ctx.fillText('' + recibo.monto, c.width / 2 + 270, 215);
      ctx.fillText('--------', c.width / 2 + 270, 255);
      ctx.font = '16px Arial';
      ctx.fillText('' + dia, c.width / 2 - 230, 250);
      ctx.fillText('' + mes, c.width / 2 - 180, 250);
      ctx.fillText('' + anio, c.width / 2 - 135, 250);
      ctx.font = '24px Arial';
      ctx.fillText('N° 000' + recibo.nro, c.width / 2 + 10, 250);
      ctx.font = '17px Arial';

      ctx.fillText('' + recibo.proximo_pago, c.width / 2 + 320, 512);
    },*/
    guardar() {
      var canvas = document.getElementById('myCanvasm2');
      let width = canvas.width;
      let height = canvas.height;
      var pdf;

      if (width > height) {
        pdf = new window.jsPDF('l', 'px', [width, height]);
      } else {
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(canvas, 'PNG', 0, 0, width, height);
      pdf.save(this.self.estudiante + '.pdf');
    },

    /** ANULAR CERTIFICADO GENERADO */
    preAnularRecibo(recibo) {
      var vue = this;
      var opt = {
        verification: 'anular',
        verificationHelp: 'Escriba "[+:verification]" para anular este recibo.',
        okText: 'Anular Recibo',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      var message = {
        title: 'Confirmar anulacion',
        body: '<br> <b>NOTA:</b> El recibo sera eliminado.',
      };
      this.$dialog
        .confirm(message, opt)
        .then(function (dialog) {
          vue.anularRecibo(recibo, dialog);
        })
        .catch(function () {});
      return;
    },
    anularRecibo(recibo, dialog) {
      const vue = this;
      let sql = gql`mutation{ eliminarRecibo(input:{id:${recibo.id}}){ok errors{message}} }`;
      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then(({ data: { eliminarRecibo } }) => {
          let datos = eliminarRecibo;
          if (datos.ok) {
            let rec = this.recibos.find((x) => x.id == recibo.id);
            if (rec) rec.nro = 'ELIMINADO';
          } else {
            let errores = JSON.stringify(eliminarRecibo.errors);
            let obj = JSON.parse(errores);
            let vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            this.$notify(error('Error', vals));
          }
          vue.cargarRecibos(null,1);
          dialog.close();
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
        });
    },
    /** FIN ANULAR CERTIFICADO */
  },
  mounted() {
    var date = new Date();
    var date2 = new Date();
    date.setDate(date.getDate() - 31);
    date2.setDate(date2.getDate() + 1);
    var d1 = date.getDate();
    var m1 = date.getMonth() + 1;
    var d2 = date2.getDate();
    var m2 = date2.getMonth() + 1;
    if (d1 < 10) d1 = '0' + d1;
    if (m1 < 10) m1 = '0' + m1;
    if (d2 < 10) d2 = '0' + d2;
    if (m2 < 10) m2 = '0' + m2;

    this.busqueda.fecha_ini = date.getFullYear() + '-' + m1 + '-' + d1;
    this.busqueda.fecha_fin = date2.getFullYear() + '-' + m2 + '-' + d2;

    this.cargarRecibos(null,1);
  },
};
</script>

